import * as React from "react";

const LazyShoutboxWidget = React.lazy(() => import("./ShoutboxWidget"));

/**
 * Loads shoutbox after idle so it stays out of the initial main-thread budget.
 */
export default function DeferredShoutboxMount() {
  const [ready, setReady] = React.useState(false);

  React.useEffect(() => {
    const schedule = () => setReady(true);
    if (typeof requestIdleCallback === "function") {
      const id = requestIdleCallback(schedule, { timeout: 2000 });
      return () => cancelIdleCallback(id);
    }
    const timer = window.setTimeout(schedule, 1500);
    return () => window.clearTimeout(timer);
  }, []);

  if (!ready) return null;

  return (
    <React.Suspense fallback={null}>
      <LazyShoutboxWidget />
    </React.Suspense>
  );
}
